export const PROCEDURE_TYPES = {
    FEE_TABULATION: 'Tabulación de Honorarios',
    VISA_VALIDATION_ATC: 'Visado / Validación de ATC',
    AUTHORIZATION_LETTER_MODIFICATION: 'Modificación Carta de Autorización',
}; 